import { enableScroll } from '../functions/enable-scroll.js';

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    const topbar = document.querySelector('.site-header__topbar');

    if (header && topbar) {
        let lastScrollY = window.scrollY;
        let ticking = false;

        function updateSticky() {
            const scrollY = window.scrollY;
            const topbarH = topbar.offsetHeight;

            if (window.innerWidth < 1025) {
                header.style.transform = '';
                header.classList.remove('site-header--scrolled');
                lastScrollY = scrollY;
                ticking = false;
                return;
            }

            if (scrollY <= topbarH) {
                header.style.transform = '';
                header.classList.remove('site-header--scrolled');
            } else if (scrollY > lastScrollY) {
                header.style.transform = `translateY(-${topbarH}px)`;
                header.classList.add('site-header--scrolled');
            } else {
                header.style.transform = 'translateY(0)';
                header.classList.add('site-header--scrolled');
            }

            lastScrollY = scrollY;
            ticking = false;
        }

        window.addEventListener('scroll', () => {
            if (!ticking) {
                requestAnimationFrame(updateSticky);
                ticking = true;
            }
        }, { passive: true });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeMobileMenu();
    });

    document
        .querySelector('[data-drawer-close]')
        ?.addEventListener('click', closeMobileMenu);

    document.querySelectorAll('[data-menu] a').forEach((a) => {
        a.setAttribute('data-menu-item', '');
    });

    document.querySelectorAll('[data-menu] .nav__submenu-trigger').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const item = btn.closest('.nav__item');
            const expanded = item?.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
    });

    document.querySelectorAll('.site-header__nav .nav__item--has-children').forEach((item) => {
        const trigger = item.querySelector('.nav__submenu-trigger');
        if (!trigger) return;

        let closeTimer;

        const openSubmenu = () => {
            clearTimeout(closeTimer);
            document.querySelectorAll('.site-header__nav .nav__item--has-children.is-open').forEach((el) => {
                if (el === item) return;
                el.classList.remove('is-open');
                el.querySelector('.nav__submenu-trigger')?.setAttribute('aria-expanded', 'false');
            });
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
        };

        const scheduleClose = () => {
            closeTimer = setTimeout(() => {
                item.classList.remove('is-open');
                trigger.setAttribute('aria-expanded', 'false');
            }, 180);
        };

        item.addEventListener('mouseenter', openSubmenu);
        item.addEventListener('mouseleave', scheduleClose);
        item.addEventListener('focusin', openSubmenu);
        item.addEventListener('focusout', scheduleClose);

        trigger.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            item.classList.toggle('is-open');
            trigger.setAttribute(
                'aria-expanded',
                item.classList.contains('is-open') ? 'true' : 'false',
            );
        });
    });

    function closeMobileMenu() {
        const burger = document.querySelector('[data-burger]');
        const menu = document.querySelector('[data-menu]');
        if (!menu?.classList.contains('menu--active')) return;
        menu?.classList.remove('menu--active');
        menu?.setAttribute('aria-hidden', 'true');
        burger?.setAttribute('aria-expanded', 'false');
        burger?.setAttribute('aria-label', 'Открыть меню');
        enableScroll();
    }
});
